<template>
  <section class="style-section">
    <div class="title-guide">模块图标</div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 200px; height: 200px" :src="url1" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">功能</div>
    <div class="content-guide">
      本模块用于建立装配式结构（空心板、T梁、小箱梁）单梁模型，
      横向分布系数则通过对应梁段车道定义参数进入模型。
      本模块适用于采用传统横向分布系数法进行计算的模型。
    </div>
    <div class="img-guide">
      <el-image
        class="size-img"
        style="width: 700px; height: 240px"
        :src="url11"
        :zoom-rate="1.2"
        :max-scale="1.5"
        :min-scale="0.2"
        :preview-src-list="srcList11"
        :initial-index="0"
        fit="cover"
      />
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">模块设计理念</div>
    <div class="content-guide">
      装配式结构设计时几乎都是采用标准图，每一次仅仅是更改湿接缝宽度和少量梁长，
      截面尺寸和钢束形状基本都是固定的。故可以考虑把标准图尺寸做成基本库，
      使用时只需要选择需要的标准库，定义一下湿接缝宽度，那么截面尺寸、钢束尺寸参数就可以不用再输入了。
      剩下只需要定义梁长、桥面荷载、横向分布系数就可以计算出模型所需的所有参数了。
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">模块使用流程</div>
    <div class="content-guide">
      <div>本模块常规使用流程如下：</div>
      <li>选择标准——选择结构类型——选择采用的标准跨径</li>
      <li>定义孔跨布置——核查材料参数——选择需要计算的梁体（边梁或中梁）</li>
      <li>输入桥面荷载</li>
      <li>选择汽车荷载——输入人群荷载——计算横向分布系数并输入</li>
      <li>核查钢筋布置参数</li>
      <li>通过“中中距”或“边中距”来快速调整梁板顶面宽度，核查几何尺寸参数</li>
      <li>核查预应力钢束线型参数，确认孔道内钢绞线根数</li>
      <li>
        保存项目文件，然后导出mct文件，mct文件导入到Midas
        Civil后即可得到计算模型
      </li>
      <div>
        使用技巧：即使没有使用现有标准库参数，待第一次修改参数完成后项目文件存盘。
        下次使用时如果仅仅是梁板中距的区别，打开项目文件后仅需通过“中中距”或“边中距”来快速调整梁板顶面宽度，
        然后调整预应力孔道内的钢绞线根数，然后重新计算横向分布系数并填写，就可以直接导出模型了。
      </div>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image
          class="size-img"
          style="width: 700px; height: 420px"
          :src="url10"
          :zoom-rate="1.2"
          :max-scale="1.5"
          :min-scale="0.2"
          :preview-src-list="srcList10"
          :initial-index="0"
          fit="cover"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">标准选择</div>
    <div class="content-guide">
      本部分用于直接套用标准图尺寸参数和钢束参数，可以减少参数输入量，加快建模效率。
      使用时先选择数据库，程序会访问远程服务器并返回该标准下的结构类型，
      然后再选择结构类型，这时程序会继续访问远程服务器并返回该结构类型下的各种跨径对应参数。
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 210px; height: 130px" :src="url2" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">结构参数</div>
    <div class="content-guide">
      <li>
        跨径组合——多跨结构只能采用“+”和“-”符号进行连接，如“3-30”、“20+20”、“29.94+30+30+29.94”。
        多跨简支结构在进行上部构造验算时仅需按单跨计算，故跨径组合可以输入“1-29.96”。
      </li>
      <li>混凝土标号——选择上部构造混凝土采用的标号</li>
      <li>预应力钢材——选择上部构造采用的预应力钢束型号</li>
      <li>预应力管道——选择上部构造预应力钢束采用的管道类型</li>
      <li>
        跨径选用——选择某一个跨径后，下方的“一般构造尺寸”和“预应力布置”均会改为该标准对应各项参数。
        该功能仅在选择调整时启动，导出mct文件中“一般构造尺寸”和“预应力布置”对应参数与该选择无关，仅与下方表格内容参数有关。
      </li>
      <li>
        部位——通过选择，会重置“一般构造尺寸”和“预应力布置”参数，导出时按照选择部位组合尺寸参数（边梁参数还是中梁参数）。
        注意B7是边梁翼缘参数，切换到边梁时方可看到示意图。
        在使用程序内置“横向分布系数计算”功能时，需要切换到边梁输入参数。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 370px; height: 130px" :src="url3" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥面荷载</div>
    <div class="content-guide">
      <li>
        沥青混凝土层厚度——输入结构宽度范围内沥青混凝土层的厚度。
        模型中该厚度乘以梁体全宽及密度（按24kN/m3取值）作为桥面荷载施加在梁体上。
        另外该厚度也用于温度梯度计算。桥梁没有该层时请输入数值0。
      </li>
      <li>
        水泥混凝土层厚度——输入结构宽度范围内水泥混凝土层的厚度。
        模型中该厚度乘以梁体全宽及密度（按26kN/m3取值）作为桥面荷载施加在梁体上。
        如果沥青混凝土厚度为0，则程序按水泥混凝土铺装以该厚度作为温度梯度计算参数。
      </li>
      <li>
        其他外加荷载——通常梁体上还存在一些其他荷载，如防撞混凝土、人行道等，
        将该部分荷载自行换算分配到计算梁体上的荷载值，输入到该栏中。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 205px; height: 130px" :src="url4" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">桥面活荷载及横向分布系数</div>
    <div class="content-guide">
      <li>
        汽车荷载——可以选择公路-Ⅰ级和公路-Ⅱ级。城-A级等效公路-Ⅰ级，城-B级等效公路-Ⅱ级。
      </li>
      <li>
        人群荷载——考虑人行道宽度后的人群荷载，该值不考虑横向分布系数，不考虑人群荷载时输入0。
      </li>
      <li>
        汽车（人群）跨中分布系数——输入汽车（人群）跨中部位计算好的横向分布系数。可以考虑使用本程序自带的“横向分布系数计算”功能计算该值。
      </li>
      <li>
        汽车（人群）端部分布系数——输入汽车（人群）端部部位计算好的横向分布系数。可以考虑使用本程序自带的“横向分布系数计算”功能计算该值。
      </li>
      <li>
        系数纵向变化长度——程序支持横向分布系数端部段与跨中段不一致，直线渐变过渡，这里输入端部变化段的长度。
        程序生成的模型通过在车道定义中每个单元的比例系数不同来实现横向分布系数不同的效果。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 450px; height: 130px" :src="url5" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">横向分布系数计算</div>
    <div class="content-guide">
      <li>W1～W12——对应示意图各部位宽度。</li>
      <li>梁板片数——桥梁梁板总片数</li>
      <li>梁板中距——梁板中心距离</li>
      <li>
        左边梁板距桥面左侧距离——该值为桥面系外侧护栏外边缘到边梁板外边缘距离，通常情况下该值取0，如遇到护栏内移的情况，根据实际情况填写。
      </li>
      <li>
        按照示意图显示的桥面各部位宽度输入对应参数值，选择设计考虑的横向分布系数计算方法，然后点击“计算”按钮即可计算出相应的横向分布系数。
      </li>
      <li>
        若人行道宽度W2或W11为0时，程序视为桥梁无人行道，故无法计算人群荷载的横向分布系数。
      </li>
      <li>
        程序在计算桥面总宽度时，除了采用梁板片数和梁板中距参数外，还会计算边梁板中心线到边梁板外边缘的值，故注意边板悬臂参数B7的取值，避免程序提示梁板宽度不足。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 700px; height: 467px" :src="url6" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">钢筋布置</div>
    <div class="content-guide">
      按照设计图纸输入顶底板纵向普通钢筋数量、型号用于抗弯承载力验算。
      同时输入梁体端部横向箍筋数量、型号、间距，用于抗剪承载力验算。
      1个单箍需要输入的箍筋根数为2。
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image style="width: 240px; height: 130px" :src="url7" :fit="fit" />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">一般构造尺寸</div>
    <div class="content-guide">
      <li>结合示意图，可以调整梁板纵向、跨中和端部的截面尺寸。</li>
      <li>
        纵向参数L4、L5用于多跨结构连续端，若孔跨布置为单孔，程序会将起点端参数L1～L3对称到终点端。
      </li>
      <li>多跨结构L4、L5参数不能为0，否则在导入Midas Civil时会出错。</li>
      <li>
        中中距——梁体之间的中心线水平距离。通过在弹窗中输入数值，程序会自动换算顶面宽度B2（相当于调整湿接缝宽度）参数值。
      </li>
      <li>
        边中距——边梁板底宽中心线到顶面外翼缘外侧的水平距离。通过在弹窗中输入数值，程序会自动换算顶面宽度B7（相当于调整外翼缘宽度）参数值。
      </li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image
          class="size-img"
          style="width: 640px; height: 540px"
          :src="url8"
          :zoom-rate="1.2"
          :max-scale="1.5"
          :min-scale="0.2"
          :preview-src-list="srcList8"
          :initial-index="0"
          fit="fill"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <section class="style-section">
    <div class="title-guide">预应力布置</div>
    <div class="content-guide">
      <li>结合示意图，可以调整梁板预应力钢束形状参数。</li>
      <li>组数代表符合该钢束线型的孔道数，根数为单个孔道内钢绞线的根数。</li>
      <li>
        参数YH3、YH6、YL3、YL4、YR4用于多跨连续结构，若孔跨布置为单孔，程序会将简支端的参数对称到终点端。
      </li>
      <li>腹板钢束没有平弯时参数可以输入0。</li>
      <li>钢束类型可以通过点击“+”、“-”进行添加。</li>
    </div>
    <div class="img-guide">
      <div class="title-img">
        <el-image
          class="size-img"
          style="width: 640px; height: 540px"
          :src="url9"
          :zoom-rate="1.2"
          :max-scale="1.5"
          :min-scale="0.2"
          :preview-src-list="srcList9"
          :initial-index="0"
          fit="cover"
        />
      </div>
    </div>
  </section>
  <el-divider></el-divider>
  <div style="height: 120px"></div>
</template>
<script>
export default {
  data() {
    return {
      url1: require("@/assets/png/unit1/1.png"),
      url2: require("@/assets/png/unit1/2.png"),
      url3: require("@/assets/png/unit1/3.png"),
      url4: require("@/assets/png/unit1/4.png"),
      url5: require("@/assets/png/unit1/5.png"),
      url6: require("@/assets/png/unit1/6.png"),
      url7: require("@/assets/png/unit1/7.png"),
      url8: require("@/assets/png/unit1/8.png"),
      url9: require("@/assets/png/unit1/9.png"),
      url10: require("@/assets/png/unit1/10.png"),
      url11: require("@/assets/png/unit1/11.png"),
      fit: "fill",
      srcList8: [require("@/assets/png/unit1/8.png")],
      srcList9: [require("@/assets/png/unit1/9.png")],
      srcList10: [require("@/assets/png/unit1/10.png")],
      srcList11: [
        require("@/assets/png/unit1/11.png"),
        require("@/assets/png/unit1/12.png"),
        require("@/assets/png/unit1/13.png"),
      ],
    };
  },
};
</script>
